import { render } from "./order-status-graphic.vue?vue&type=template&id=84edcfe4&scoped=true"
import script from "./order-status-graphic.vue?vue&type=script&lang=js"
export * from "./order-status-graphic.vue?vue&type=script&lang=js"

import "./order-status-graphic.vue?vue&type=style&index=0&id=84edcfe4&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84edcfe4"]])

export default __exports__